var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userInfo.avatar)?_c('img',{attrs:{"src":_vm.userInfo.avatar,"alt":_vm.userInfo.nickname},on:{"click":_vm.toUserInfo}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }